import React from 'react'

function RightArrow() {
  return (
    <span className='right-arrow videoCarouselArrow'><i class="fa fa-arrow-right" aria-hidden="true"></i>
    </span>
  )
}

export default RightArrow